<template>
  <ipo3-page>
    <template slot="title">視頻清單</template>
    <template slot="tools">
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">添加視頻</el-button>
      <ipo3-popload ref="popload" @sucess="onSucess"></ipo3-popload>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >{{$t('btns.edit')}}</el-button>
                                <el-button
                  @click="onDelete(scope.$index, scope.row.id)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "video-index",
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "地址", id: "path" },
        { name: "創建時間", id: "create_time" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onSucess() {
      this.getData();
    },
    getData(page=1,size=10) {
      let self = this;
      this.$http.get("/admin/videos/index",{page:page,size:size}).then(res => {
        let {total} = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },
    onCreate() {

      this.$router.push({path:`/video/edit/`})
      //this.$refs.popload.onOpenFile();
    },
    onDelete(index,value)
    {
      var self = this;
      this.$http.post("/admin/videos/delete",{id:value}).then(res=>{
        if(res.code==200)
        {
          self.getData();
          self.$message.success("删除成功")
        }else
        {
          self.$message.error(res.msg);
        }
      })
    },
    onHandle(index, value) {
      
      this.$router.push({path:`/video/edit/${value}`})

    },
    handleCurrentChange(value)
    {
      this.currentPage = value
        this.getData(this.currentPage,this.paginate);
    },
    handleSizeChange(size)
    {
        this.paginate = size;
        this.getData(this.currentPage,this.paginate);
    },
  }
};
</script>